import ClipboardInterface from "./ClipboardInterface";

class DOMClipboardAdapter implements ClipboardInterface {
    readText(): Promise<string> {
        return navigator.clipboard.readText();
    }
    writeText(text: string): Promise<void> {
        return navigator.clipboard.writeText(text);
    }
    write(data: ClipboardItems): Promise<void> {
        return navigator.clipboard.write(data);
    }
}

export default DOMClipboardAdapter;
